import Modal from './Modal';
export { default as Heading } from './Heading';
export { Footer, Content } from './styled';
export default Modal;
